import React from 'react'
import styles from './PopupCoin.module.css';
function RewardRule({onClose}: {onClose: () => void}) {
  return (
    <div className={styles.dfx_coinPopupOverlay} onClick={onClose}>
        <div className={`${styles.dfx_coinPopupBox} ${styles.RewardRuleContainer}`} onClick={(e) => e.stopPropagation()}>
          <button className={styles.dfx_coinPopupCloseBtn} onClick={onClose}>
              <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none">
              <path d="M10.3708 0.243332C10.0571 -0.0703851 9.55028 -0.0703851 9.23656 0.243332L5.30303 4.16882L1.3695 0.235288C1.05578 -0.0784293 0.549005 -0.0784293 0.235288 0.235288C-0.0784293 0.549005 -0.0784293 1.05578 0.235288 1.3695L4.16882 5.30303L0.235288 9.23656C-0.0784293 9.55028 -0.0784293 10.0571 0.235288 10.3708C0.549005 10.6845 1.05578 10.6845 1.3695 10.3708L5.30303 6.43724L9.23656 10.3708C9.55028 10.6845 10.0571 10.6845 10.3708 10.3708C10.6845 10.0571 10.6845 9.55028 10.3708 9.23656L6.43724 5.30303L10.3708 1.3695C10.6764 1.06382 10.6764 0.549006 10.3708 0.243332Z" fill="#A2A2A2"/>
            </svg>
          </button>
          <h2 className={styles.dfx_coinPopupContent}>Rewards Rules</h2>
          <ul>
            <li>You can check-in once per day. Continuously check in to gain more benefits.</li>
            <li>If you miss a check-in day, your streak will be reset.</li>
            <li>Reward Coins can be used like regular Coins to unlock content.</li>
            <li>You can check your reward history under “My Balance”.</li>
          </ul>
        </div>
    </div>  
  )
}   

export default RewardRule